import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";

export default {
    name: "AdminResumeDetail",
    components: {
        MainLayout
    },

    data() {
        return {
            resume: {
                id: "",
                name: "",
                path: "",
                nrc_number: "",
                nationality: "",
                religion: "",
                phone_number: "",
                email: "",
                facebook: "",
                linkin: "",
                gender: "",
                marital_status: "",
                date_of_birth: "",
                contact_address: "",
                permanent_address: "",
                position: "",
                expected_salary: "",
                education_detail: "",
                other_certificate: "",
                experience_detail: ""
            }
        };
    },

    methods: {
        getResumeDetail() {
            axios.get("/applicant/resume/detail/" + this.$route.params.id)
                .then(response => {
                    this.resume = response.data;
                })
                .catch(error => {
                    console.log("Resume Detail API error:::::>", error.response.data);
                });
        }
    },

    mounted() {
        this.getResumeDetail();
    }
};